import { useA11yTexts, useComponentTexts } from "Store/texts/hooks";

import Dialog from "@storeblocks/dialog";
import { TranslatedText } from "Store/texts/interfaces";
import React from "react";
import { Description } from "./Description";

interface Props {
  readonly open: boolean;
  readonly closeDrawer: () => void;
  readonly forEditButton?: boolean;
}

export const AdviceDialog = ({
  open,
  closeDrawer,
  forEditButton = false,
}: Props): React.ReactElement => {
  const [{ callUsHint }, lang] = useA11yTexts();
  const [{ advisorProductIntroTile, editAdvisorProduct }] = useComponentTexts();
  const texts = forEditButton ? editAdvisorProduct : advisorProductIntroTile;

  const getDescriptions = (
    descriptions: TranslatedText[],
  ): React.ReactElement[] =>
    descriptions.map((paragraph: TranslatedText, index: number) => (
      <React.Fragment key={paragraph[lang]}>
        <Description
          key={paragraph[lang]}
          paragraph={paragraph}
          lang={lang}
          phoneNumber={callUsHint.phoneNumber}
        />
        {index < descriptions.length - 1 && <br />}
      </React.Fragment>
    ));

  return (
    <Dialog
      open={open}
      heading={texts.title[lang]}
      onClose={closeDrawer}
      onConfirm={closeDrawer}
      confirmButtonLabel={texts.button[lang]}
      trigger={null}
    >
      {getDescriptions(texts.descriptions)}
    </Dialog>
  );
};
